
module.cC({
    name: 'ViewProgramInitiativeController',
    inject: ['$scope', 'initiative', 'grantYears'],
    data: {
        initiative: 'initiative',
        items: 'initiative.items',
    },

    init: function() {
      this.$.grantYears = this._mapGrantYears(this.grantYears);
    },

    methods: {
        _mapGrantYears: function(years) {
            return years.reduce(function(obj, year) {
                obj[year.year] = year;
                return obj;
            }, {});
        },
    },
});
